import { getRequest } from '../../../middlewares/api/actions';
import { getNodePingUrl } from '../../../constants/urls';

export const ENDPOINT_DROPDOWN_NODE_PING = 'ENDPOINT_DROPDOWN_NODE_PING';

export const pingNode = () => getRequest(
  ENDPOINT_DROPDOWN_NODE_PING,
  getNodePingUrl(),
  undefined,
  undefined,
  undefined,
  14000
);



// WEBPACK FOOTER //
// ./src/page/header/endpoint-dropdown/actions.js